/* eslint-disable react/prop-types */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Glyphicon } from 'react-bootstrap';
import SorterPoint from './SorterPoint';

export default ({ activeSort, name }) =>
  activeSort?.name === name ? (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    <SorterPoint up={activeSort.up} />
  ) : (
    <Glyphicon glyph='chevron-up' style={{ visibility: 'hidden', width: 0 }} />
  );
